import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Account, AccountResponse } from '../models/account.model';

export interface User {
  id: number;
  login: string;
  name: string;
  mail: string;
  status: string;
  timestamp: string;
  isAdmin: boolean;
}

export interface UserResponse {
  success: boolean;
  status: number;
  body: User;
}

export interface UsersResponse {
  success: boolean;
  status: number;
  body: User;
}

@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(private http: HttpClient) {}

  // 現在ログイン中のユーザー情報を取得
  getCurrentUser(): Observable<UserResponse> {
    return this.http.get<UserResponse>('/api/druser/me');
  }

  // 任意のユーザーIDを指定して取得（必要な場合）
  getUserById(id: number): Observable<UserResponse> {
    return this.http.get<UserResponse>(`/api/druser/${id}`);
  }

  // 任意のユーザーIDを指定して取得（必要な場合）
  getUsersById(id: number[]): Observable<UsersResponse> {
    return this.http.get<UsersResponse>(`/api/drusers/${id.join(',')}`);
  }

  // 指定ユーザーの口座情報を取得
  getUserAccounts(id: number, ym?: number): Observable<AccountResponse> {
    const params = ym ? new HttpParams().set('ad', String(ym)) : undefined;
    return this.http.get<AccountResponse>(`/api/druser/accounts/${id}`, { params });
  }

  parseAccount(res: AccountResponse) {
    return res.body.map(x => {
      x.enroll = new Date(x.enroll);
      x.chg = new Date(x.chg);
      x.res_b = parseInt(x.res_b.toString());
      x.cancel = x.cancel ? new Date(x.cancel) : null;
      x.hdc = parseFloat(x.hdc.toString());
      x.bal_a = parseFloat(x.bal_a.toString());
      x.swap = parseFloat(x.swap.toString());
      x.soneki = parseFloat(x.soneki.toString());
      x.nyukin = parseFloat(x.nyukin.toString());
      x.shukkin = parseFloat(x.shukkin.toString());
      x.hc_a = parseFloat(x.hc_a.toString());
      x.hc_b = parseFloat(x.hc_b.toString());
      x.bal_b = parseFloat(x.bal_b.toString());
      x.pos = parseFloat(x.pos.toString());
      x.bal_c = parseFloat(x.bal_c.toString());
      x.rate_a = parseFloat(x.rate_a.toString());
      x.rate_b = parseFloat(x.rate_b.toString());

      return x;
    });
  }

  parseData(res: UsersResponse) {
    const x = res.body;
    x.id = parseInt(x.id as any);
    return x;
  }

}
